import { render, staticRenderFns } from "./ErrorComponent.vue?vue&type=template&id=0ad95dc6&scoped=true"
import script from "./ErrorComponent.vue?vue&type=script&lang=js"
export * from "./ErrorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad95dc6",
  null
  
)

export default component.exports